import {
  createBrowserImageBackend,
  validateDecorations,
  validateFabrics,
  validateFactory,
  validateFamily,
  validatePositions,
  validateSpecs,
  type ValidationIssue,
  type ValidationResult,
} from "@unique-wool/specs-validation";
import type { SpecsCatalog } from "./specsModel/catalog";
import { SpecsModel } from "./specsModel/SpecsModel";
import {
  type SpecsEntityType,
  upsertSpecsSnapshotIntoCatalog,
} from "./specsModel/specsLib";
import { SpecsFamiliesModel } from "./specsModel/SpecsFamiliesModel";
import { SpecsFabricsModel } from "./specsModel/SpecsFabricsModel";
import { SpecsDecorationsModel } from "./specsModel/SpecsDecorationsModel";

export async function validateSpecsModel(
  importSpecs: SpecsCatalog,
  model: SpecsModel
): Promise<ValidationResult> {
  return model.validate(
    {
      fabrics: importSpecs.fabrics,
    },
    {
      imageBackend: createBrowserImageBackend(),
    }
  );
}

export async function validateSpecsEntityModel(
  specType: SpecsEntityType,
  importSpecs: SpecsCatalog,
  model: SpecsFamiliesModel | SpecsFabricsModel | SpecsDecorationsModel
): Promise<ValidationResult> {
  const nextCatalog = upsertSpecsSnapshotIntoCatalog(
    importSpecs,
    specType,
    model.save() as Record<string, unknown>
  );

  if (specType === "fabric") {
    const issues: ValidationIssue[] = await validateFabrics(nextCatalog);
    return {
      valid: issues.length === 0,
      issues,
    };
  }

  return validateGenericSpecsCatalog(nextCatalog);
}

export async function validateGenericSpecsCatalog(
  specs: SpecsCatalog
): Promise<ValidationResult> {
  const issues: ValidationIssue[] = [
    ...(await validateFamily(specs)),
    ...(await validateFabrics(specs)),
    ...(await validateDecorations(specs)),
    ...(await validatePositions(specs)),
    ...(await validateFactory(specs)),
  ];

  return {
    valid: issues.length === 0,
    issues,
  };
}
